import { FuseAnimate, FusePageCarded } from '@fuse';
import _ from "@lodash";
import { TextField, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';
import PesquisaPainel from 'app/Core/Components/PesquisaPainel/PesquisaPainel';
import TogglePesquisa from 'app/Core/Components/PesquisaPainel/TogglePesquisa';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import React from 'react';
import { MdPin } from "react-icons/md";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import CIDList from './CIDList';
import * as Actions from './Store/Actions/CIDActions';
import CIDReducer from './Store/Reducers/CIDReducer';

const filtrosDisponiveis = [
    { "name": "descricao", "label": "Descrição", "value": "descricao", "tipo": "text" }
]

const styles = theme => ({
    addButton: {
        position: 'absolute',
        right: 12,
        bottom: 12,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

class CIDApp extends XAPPComponent {
    state = {}

    listFilter = (_AFilter) => {
        let { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        this.props.list("SELECIONAR", xappRouteParams, _AFilter);
    }

    getFiltro = () => {
        const form = this.state;
        var AArray = [];
        filtrosDisponiveis.forEach(item => {
            if (!_.isUndefined(form[item.name]) && !_.isNull(form[item.name]) && form[item.name].length > 0) {
                AArray.push({ Campo: item.value, Operador: (item.tipo === "text" ? "LIKE" : "="), Valor: form[item.name] });
            }
        });
        return { AND: AArray }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    pesquisar = (_AUseFiltro = true) => {
        this.listFilter(_AUseFiltro ? this.getFiltro() : null);
        if (!_.isUndefined(this.PesquisaPainel)) {
            this.PesquisaPainel.togglePainel("CID", _AUseFiltro ? this.getCountFiltro() : 0, this.clearFiltro);
        }
    }

    clearFiltro = () => {
        let form = {};
        filtrosDisponiveis.forEach(item => {
            form[item.name] = null;
        });
        this.setState(_.set({ ...form }));
        //this.pesquisar(false);
    }

    getCountFiltro = () => {
        const form = this.state;
        var AResult = 0;
        filtrosDisponiveis.forEach(item => {
            if (!_.isUndefined(form[item.name]) && !_.isNull(form[item.name]) && form[item.name].length > 0) {
                AResult++;
            }
        });
        return AResult;
    }

    render() {
        const { isLookup, campoid, campolabel, onChange } = this.props;
        const xappRouteParams = this.props.match.params;
        const form = this.state;
        return (
            <React.Fragment>
                <PesquisaPainel
                    id="CID"
                    anchor="left"
                    onRef={instance => this.PesquisaPainel = instance}
                >
                    <div className={"flex flex-col p-12 text-center items-center"}>
                        {_.uniqBy(filtrosDisponiveis, "name").map(item => (
                            <TextField
                                className="mb-12"
                                id={item.name}
                                name={item.name}
                                label={item.label}
                                value={!_.isNull(form[item.name]) ? form[item.name] : ""}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                type={item.tipo}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        ))}
                    </div>
                    <div className="flex p-12 gap-6">
                        <div className="flex-1" />
                        <XAPPButton
                            className="text-white"
                            label="Limpar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="close"
                            iconProps="text-20 mr-8"
                            onClick={() => this.clearFiltro()}
                        />
                        <XAPPButton
                            className="text-white"
                            label="Pesquisar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="search"
                            iconProps="text-20 mr-8"
                            onClick={() => this.pesquisar()}
                        />

                    </div>
                </PesquisaPainel>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageCarded
                        classes={{
                            contentWrapper: "p-0",
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: "w-256 border-0",
                            header: "w-full min-h-48 h-48 max-h-48 flex",
                            topBg: "min-h-48 h-48"
                        }}
                        header={
                            <div className="w-full flex items-center">
                                <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                    <Typography className="flex text-white items-center" variant="h6">
                                        <MdPin className="text-24 text-white mx-8" />
                                        {"CIDs"}
                                    </Typography>
                                </FuseAnimate>
                                <div className="flex-1" />
                                <TogglePesquisa id={"CID"} />
                            </div>
                        }
                        content={
                            <CIDList
                                xappRouteParams={xappRouteParams}
                                isLookup={isLookup}
                                onChange={onChange}
                                campoid={campoid}
                                campolabel={campolabel}
                            />
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                </CatchErro>
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
    }, dispatch);
}

function mapStateToProps({ CIDApp }) {
    return {
        CID: CIDApp.data,
        selectedCIDId: CIDApp.selectedCIDId,
        searchText: CIDApp.searchText,
    }
}

export default withReducer('CIDApp', CIDReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CIDApp))));
